// extracted by mini-css-extract-plugin
export default {"dispatch-message":"DispatchMessage_dispatch-message__CSFPH","dispatch-message__image":"DispatchMessage_dispatch-message__image__UQ2lO"};